import React from 'react';
import { Link } from 'react-router-dom';

const WificallSideBarItem = ({ url, name, src }) => {
  return (
    <li className="s-sidebar__nav-link">
      <Link to={url} target="_self">
        <span>
          <img alt="side bar item pic" src={src} />
        </span>
        <small>{name}</small>
      </Link>
    </li>
  );
};

export default WificallSideBarItem;
